export const LOCAL_STORAGE_TOKEN_KEY = "__moveup_dashboard_token__";
export const LOCAL_STORAGE_AUTHORITY_KEY = "__moveup_dashboard_user_authority__";
